// Русский язык
export default {
	status: {
		All: "Все",
		Pending: "В ожидании",
		Frozen: "Замороженный",
		Completed: "Завершено",
		Undone: "Не выполнено"
	},
	TotalAmount: "Общая сумма",
	Profit: "Прибыль",
	Expire: "Истекает"
};
